<template>
  <div class="stats">
    <div class="stats__line stats__line--feedback">
      <button @click="share('twitter')">{{$t('social.shareOnTwitter')}}</button>
    </div>
    <div class="stats__line stats__line--total">
      <span class="stats__line__label">
        {{$t('stats.globalPoints')}}
      </span>
      {{ (globalPoints || '20,000,000+') | number }}
    </div>
    <div class="stats__line stats__line--points">
      <span class="stats__line__label stats__line__label--block">
        {{$t('stats.points')}}
      </span>
      {{ points | number }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import share from 'lib/share';

export default {
  computed: mapState({
    globalPoints: state => state.globalPoints,
    points: state => state.points,
  }),
  methods: {
    share,
  },
};
</script>

<style lang="scss" scoped>
.stats {
  color: #888;
  font-size: .875em;
  padding: .8em 1.5em;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0;

  @media (max-width: 500px), (max-height: 500px) {
    display: none
  }

  &__line {
    border-bottom: 1px solid #bbb;
    padding: .2rem 0;

    &:last-child {
      border-bottom: none;
    }

    &--points {
      font-weight: 100;
      font-size: 4em;
    }

    &__label {
      font-size: .875rem;
      font-weight: normal;

      &--block {
        display: block;
        margin-bottom: -0.5em;
      }
    }
  }

  a,
  button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font: inherit;
    padding: 0;
    text-decoration: none;

    &:hover {
      color: #444;
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Stats.vue?643af849